import type { FC, SVGProps } from 'react';

export const ExitIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_985_7314)">
        <rect width="14" height="14" fill="white" fillOpacity="0.01" />
        <path
          fill="currentColor"
          d="M12.5221 0.998047C12.7874 0.998293 13.0014 1.21226 13.0016 1.47754V3.04395C13.0014 3.1108 12.9468 3.16382 12.8815 3.16406H12.0406C11.9751 3.16406 11.9207 3.10941 11.9205 3.04395V2.07812H2.07971V11.9189H11.9186V10.9531C11.9186 10.8875 11.9731 10.8331 12.0387 10.833H12.8795C12.9451 10.833 12.9996 10.886 12.9996 10.9531V12.5186C12.9996 12.7842 12.7857 12.998 12.5201 12.998H1.47913C1.21365 12.9979 0.999634 12.7841 0.999634 12.5186V1.47754C0.999858 1.21221 1.21379 0.998219 1.47913 0.998047H12.5221ZM10.7496 5.24805C10.7498 5.14362 10.87 5.08419 10.9528 5.14941L13.1705 6.89941C13.1854 6.91109 13.1974 6.92634 13.2057 6.94336C13.214 6.96035 13.2184 6.97915 13.2184 6.99805C13.2184 7.01689 13.2139 7.03577 13.2057 7.05273C13.1974 7.06968 13.1853 7.08502 13.1705 7.09668L10.9528 8.84668C10.8715 8.91222 10.7496 8.85271 10.7496 8.74805V7.56055H5.84338C5.77469 7.56048 5.71838 7.50425 5.71838 7.43555V6.56055C5.7185 6.49194 5.77477 6.43562 5.84338 6.43555H10.7496V5.24805Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_985_7314">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
